'use strict';

var styled = require('styled-components');
var cssUnits = require('../../helpers/css-units.js');
var number = require('../../helpers/number.js');
var breakpoints = require('../../theme/breakpoints.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Backdrop = styled__default.default.div `
  position: fixed;
  z-index: ${({ theme }) => theme.designTokens.modalBackdropZIndex};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.designTokens.modalBackdropBackgroundColor};
  opacity: ${({ theme }) => theme.designTokens.modalBackdropOpacity};
`;
const getViewPortWidth = (viewport, theme) => {
    switch (viewport) {
        case 'tablet':
            return theme.designTokens.modalTabletWidth;
        case 'laptop':
            return theme.designTokens.modalLaptopWidth;
        case 'desktop':
        default:
            return theme.designTokens.modalDesktopWidth;
    }
};
const getDialogWidth = (theme, viewport, size, fullWidth) => {
    if (fullWidth)
        return getDialogFullWidth(theme);
    if (size === 'large')
        return getDialogSizeLargeWidth(theme, viewport);
    return getViewPortWidth(viewport, theme);
};
const getDialogSizeLargeWidth = (theme, viewport) => {
    switch (viewport) {
        case 'laptop':
        case 'desktop':
            return theme.designTokens.modalLargeWidth;
        default:
            return getDialogFullWidth(theme);
    }
};
const getDialogFullWidth = (theme) => `calc(100% - ${cssUnits.pxToRem(cssUnits.remToPx(theme.designTokens.modalFullWidthSpaceToSide) * 2)})`;
const getDialogLeft = (theme, viewport, size, fullWidth) => {
    if (fullWidth)
        return theme.designTokens.modalFullWidthSpaceToSide;
    if (size === 'large')
        return getDialogPositionLeftSizeLarge(theme, viewport);
    return getDialogPositionLeft(getViewPortWidth(viewport, theme));
};
const getDialogPositionLeft = (dialogWidthInRem) => `calc(50% - ${cssUnits.pxToRem(cssUnits.remToPx(dialogWidthInRem) / 2)})`;
const getDialogPositionLeftSizeLarge = (theme, viewport) => {
    switch (viewport) {
        case 'laptop':
        case 'desktop':
            return `calc(50% - ${cssUnits.pxToRem(cssUnits.remToPx(theme.designTokens.modalLargeWidth) / 2)})`;
        default:
            return theme.designTokens.modalFullWidthSpaceToSide;
    }
};
const dialogStylesByDevice = {
    mobile: styled.css `
    width: ${({ theme }) => theme.designTokens.modalMobileWidth};
    bottom: ${({ theme }) => theme.designTokens.modalMobileBottom};
    left: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `,
    tablet: styled.css `
    width: ${({ theme, fullWidth, size }) => getDialogWidth(theme, 'tablet', size, fullWidth)};
    left: ${({ theme, fullWidth, size }) => getDialogLeft(theme, 'tablet', size, fullWidth)};
    top: ${({ positionTop }) => (positionTop ? `${positionTop}px` : '-1000px')};
  `,
    laptop: styled.css `
    width: ${({ theme, fullWidth, size }) => getDialogWidth(theme, 'laptop', size, fullWidth)};
    left: ${({ theme, fullWidth, size }) => getDialogLeft(theme, 'laptop', size, fullWidth)};
    top: ${({ positionTop }) => (positionTop ? `${positionTop}px` : '-1000px')};
  `,
    desktop: styled.css `
    width: ${({ theme, fullWidth, size }) => getDialogWidth(theme, 'desktop', size, fullWidth)};
    left: ${({ theme, fullWidth, size }) => getDialogLeft(theme, 'desktop', size, fullWidth)};
    top: ${({ positionTop }) => (positionTop ? `${positionTop}px` : '-1000px')};
  `,
};
const Dialog = styled__default.default.div `
  position: fixed;
  z-index: ${({ theme }) => theme.designTokens.modalZIndex};
  display: ${({ isOpened }) => (isOpened ? 'block' : 'none')};
  box-shadow: ${({ theme }) => theme.designTokens.modalShadow};
  background: ${({ theme }) => theme.designTokens.modalBackgroundColor};
  color: ${({ theme }) => theme.designTokens.modalTextColor};
  border-radius: ${({ theme }) => theme.designTokens.modalRadius};

  overflow-x: hidden;

  ${breakpoints.mediaQueryFor('mobile')} {
    ${({ isOpened }) => isOpened && dialogStylesByDevice.mobile}
  }
  ${breakpoints.mediaQueryFor('tablet')} {
    ${({ isOpened }) => isOpened && dialogStylesByDevice.tablet}
  }
  ${breakpoints.mediaQueryFor('laptop')} {
    ${({ isOpened }) => isOpened && dialogStylesByDevice.laptop}
  }
  ${breakpoints.mediaQueryFor('desktop')} {
    ${({ isOpened }) => isOpened && dialogStylesByDevice.desktop}
  }
`;
const Section = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.modalPaddingY} 0;
  max-height: ${({ maxHeight = '100%' }) => (number.isNumber(maxHeight) ? `${maxHeight}px` : maxHeight)};
  overflow-y: auto;
  ${breakpoints.mediaQueryFor('mobile')} {
    padding: ${({ theme }) => theme.designTokens.modalMobilePaddingY} 0;
  }
`;
const SectionItem = styled__default.default.div `
  padding: 0 ${({ theme }) => theme.designTokens.modalItemPaddingX};
`;
const Styled = {
    Backdrop,
    Dialog,
    SectionItem,
    Section,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
